// Diagnostic codes only. No cookies, storage, network, user/variant/order IDs,
// exception messages, stacks, URLs, form values or session recording.
(() => {
  if (window.PerfectionDiagnostics) return;
  const allowed = new Set(['asset_load_failed', 'script_error', 'promise_rejection',
    'cart_add_failed', 'cart_update_failed', 'cart_render_failed']);
  const entries = [];
  const seen = new Set();
  const page = document.querySelector('[data-perfection-page]')?.dataset.perfectionPage || 'other';
  const pageType = ['index', 'product', 'collection', 'cart', 'page', '404'].includes(page) ? page : 'other';
  window.PerfectionDiagnostics = {
    report(code) {
      if (!allowed.has(code) || seen.has(code)) return;
      seen.add(code);
      const entry = Object.freeze({ code, page: pageType });
      entries.push(entry);
      window.dispatchEvent(new CustomEvent('perfection:diagnostic', { detail: entry }));
    },
    snapshot: () => entries.map((entry) => ({ ...entry })),
  };
  window.addEventListener('error', (event) => {
    const asset = ['SCRIPT', 'LINK', 'IMG', 'VIDEO', 'AUDIO'].includes(event.target?.tagName);
    if (asset) window.PerfectionDiagnostics.report('asset_load_failed');
    // Lazy <source data-src> nodes and codec fallback attempts can emit plain
    // DOM error events. They are not JavaScript exceptions. Fatal media errors
    // are handled on the parent VIDEO/AUDIO element above.
    else if (event instanceof ErrorEvent) window.PerfectionDiagnostics.report('script_error');
  }, true);
  window.addEventListener('unhandledrejection', () => window.PerfectionDiagnostics.report('promise_rejection'));
})();
